import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { ReducersMapObject, Store } from 'redux'

import { isSubApplication } from 'src/core/classes/helpers/getAppId'
import { IState, TInitialState, TInitStoreOptions } from 'src/core/store/state'

import { getMiddleware, rootReducer } from './reducer'

// @ts-ignore TODO WAIT MF
const getGlobalStore = () => window.globalStore as Store<IState>

export const initStore = (appsStore: ReducersMapObject, options: TInitStoreOptions) => {
  if (isSubApplication()) {
    if (getGlobalStore()) {
      return getGlobalStore()
    }
  }

  // @ts-ignore
  window.globalStore = configureStore({
    reducer: rootReducer(appsStore),
    middleware: getMiddleware(options.middleware, options.loadedMiddlewares),
    devTools: options.devTools,
  })

  return getGlobalStore()
}

export const store = getGlobalStore()
type RootState = ReturnType<typeof store.getState>
type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export type { IState, TInitialState, RootState, AppDispatch }
